export default __webpack_public_path__ + "static/Fig 11 - CCTV-36c6eca601bedb3528cb71a7d87401fb.pdf";